"use client";

import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { memo } from "react";

export type HeroDarkProps = {
  title: string;
  description: string;
  descriptionClassName?: string;
  primaryButton?: {
    href: string;
    label: string;
  } | null;
  secondaryButton?: {
    href: string;
    label: string;
  } | null;
} & React.ComponentProps<"section">;

const HeroDark = ({
  className,
  descriptionClassName,
  title,
  description,
  primaryButton,
  secondaryButton,
}: HeroDarkProps) => {
  return (
    <section
      className={cn(
        "section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-blue-800 lg:bg-[#1b1f3b]",
        className
      )}
    >
      <div className="container py-12 lg:py-[50px] mx-auto">
        <div className="flex flex-col lg:justify-center lg:text-center gap-8">
          <div className="grid grid-cols-1 gap-2 md:gap-8 text-white">
            <Typography variant="headingMain" className="w-full">
              <h1>{title}</h1>
            </Typography>
            <Typography
              variant="subHeadingMd"
              asChild
              className={cn("lg:mx-auto lg:max-w-2xl lg:text-xl lg:leading-[150%]", descriptionClassName)}
            >
              <p>{description}</p>
            </Typography>
          </div>
          {(!!primaryButton || !!secondaryButton) && (
            <div className="grid grid-cols-1 gap-4 sm:flex lg:justify-center flex-wrap lg:gap-2.5">
              {!!primaryButton && (
                <Button
                  asChild
                  variant="primary"
                  className="sm:w-[247px] h-[48px]"
                >
                  <Link href={primaryButton.href} className="!text-base w-full">
                    {primaryButton.label}
                  </Link>
                </Button>
              )}
              {!!secondaryButton && (
                <Button
                  asChild
                  variant="primary-outline"
                  className="h-[48px] sm:w-[141px]"
                >
                  <Link
                    href={secondaryButton?.href}
                    className="!text-base w-full"
                  >
                    {secondaryButton?.label}
                  </Link>
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(HeroDark);
